import React from 'react';
export function Footer() {
  return <footer className="py-6 px-4 sm:px-6 bg-warmgray text-center text-white/70 text-[11px] sm:text-xs" data-id="element-57" data-mp="32wd2qgad7ltj">
      <p className="font-semibold mb-2" data-id="element-58" data-mp="3ggk90wy2pg0l">
        © 2026 SENIOR FITNESS COACH PRO™ — Tutti i Diritti Riservati.
      </p>
      <p className="leading-relaxed max-w-3xl mx-auto mb-3" data-id="element-59" data-mp="32m1c310wf4po">
        Le informazioni contenute in questo sistema rappresentano materiale
        professionale di supporto per allenatori di fitness senior e personal
        trainer. Non sostituiscono il giudizio professionale dell'allenatore né
        eventuali indicazioni mediche. Ogni programma deve essere adattato alle
        capacità, alle condizioni fisiche e agli obiettivi individuali di ciascun
        cliente.
      </p>
      <div className="flex justify-center items-center gap-2 font-semibold" data-id="element-60" data-mp="3qfjj8jyhljpp">
        <a href="#" className="hover:text-gold transition-colors" data-id="element-61" data-mp="29xlz0k1buwgz">
          Termini e Condizioni
        </a>
        <span data-id="element-62" data-mp="2ezl2rv0zbveg">•</span>
        <a href="#" className="hover:text-gold transition-colors" data-id="element-63" data-mp="2evxaez79tf1b">
          Privacy Policy
        </a>
        <span data-id="element-64" data-mp="3gagyrmubl72o">•</span>
        <a href="#" className="hover:text-gold transition-colors" data-id="element-65" data-mp="3gaz3l7v1stm7">
          Contatti
        </a>
      </div>
    </footer>;
}